module.exports = __webpack_public_path__ + "img/Group.c5a2464a.svg";